import {Injectable} from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';
import {AuthService} from './auth.service';
import {BaseWebservice} from '../../../shared/base/base.webservice';

@Injectable({providedIn: 'root'})
export class CompletionGuard implements CanActivate {
    constructor(private authService: AuthService, private service: BaseWebservice) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.service.plan != null && this.service.plan_paid == true
        if (currentUser) {
            // logged in so return true
            return true;
        } else {
            setTimeout(args => {
                window.location.reload()

            }, 10)
            return false;
        }

    }
}
